import clsx from 'clsx';
import { FC } from 'react';

import { Skeleton } from 'src/general/components/Skeleton/Skeleton';

interface Props {
  variant?: 'plp' | 'default';
}
export const ProductCardLoading: FC<Props> = ({ variant = 'plp' }) => (
  <li
    className={clsx(
      'relative isolate m-0 overflow-hidden rounded-lg bg-for-neu-tie1',
      'box-border grid h-full border border-bor-neu-mut p-3',
      'shadow-elevation-0dp focus-within:shadow-elevation-0dp hover:shadow-elevation-0dp',
      variant === 'default' && 'grid-cols-[1fr_56px]',
      variant === 'plp' && 'grid-cols-1 pb-0',
    )}
  >
    <div className="col-span-2 mb-4 aspect-video w-full rounded-xs bg-(image:--gradient-product-placeholder)" />

    <p className="c-fs-body1 col-start-1 pb-0.5 pl-1">
      <Skeleton />
    </p>
    <p className="c-fs-body2 col-start-1 pb-0.5 pl-1">
      <Skeleton size={50} />
    </p>
    <p className="c-fs-body2 col-start-1 pb-3 pl-1">
      <Skeleton size={40} />
      &ensp;•&ensp;
      <Skeleton size={40} />
    </p>
    {variant === 'default' && (
      <aside className="relative z-20 col-start-2 row-span-3 row-start-2 justify-self-end pr-1">{/* Empty */}</aside>
    )}
    <footer className="col-span-2 flex flex-col justify-end px-1 pt-0">
      <p>
        <Skeleton size={50} />
      </p>

      <p>
        <Skeleton />
      </p>

      {variant !== 'default' && (
        <aside className="-mx-4 mt-4 grid h-12 grid-cols-2 border-t border-bor-neu-bas">
          <div className="c-shade_container c-shade_container--grey min-h-12 rounded-none" />
          <div className="c-shade_container c-shade_container--grey min-h-12 rounded-none" />
        </aside>
      )}
    </footer>
  </li>
);
